
import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.use(Router)
export default new Router({
    //mode: 'history',
    base: '/web/',
  routes: [
   {
        path: '/login',
        name: 'login',
        component: resolve=>(require(["@/components/login"],resolve)),
    },
    {
      path: '/chatgpt',
      name: 'chatgpt',
      component: resolve=>(require(["@/components/ChatGPT"],resolve)),
  },
    {
        path: '/ForgetPassword',
        name: 'ForgetPassword',
        component: resolve=>(require(["@/components/ForgetPassword"],resolve)),
    },
    {
        path: '/app',
        name: 'app',
        component: resolve=>(require(["@/components/homeApp"],resolve)),
        children: [
          {name: 'app_invoice',
          path: '/app_invoice',
          component: resolve=>(require(["@/components/appInvoice"],resolve)),
        },
          {name: 'app_base',
          path: '/app_base',
          component: resolve=>(require(["@/components/appBaseData"],resolve)),
        },
          {name: 'app_user',
          path: '/app_user',
          component: resolve=>(require(["@/components/Setting"],resolve)),
        }
        ]
      },

    {
        path: '/shop',
        name: 'shop',
        component: resolve=>(require(["@/components/Shop"],resolve)),
    }, {
        path: '/shopsubmit',
        name: 'shopsubmit',
        component: resolve=>(require(["@/components/ShopSubmit"],resolve)),
    },
    {
        path: '/',
        component: resolve=>(require(["@/components/home"],resolve)),
          children: [
            {
                path: '/invoice',
                name: 'invoice',
                component: resolve=>(require(["@/components/Invoice"],resolve)),
            },
            {
                path: 'ShopingCart',
                name: 'ShopingCart',
                component: resolve=>(require(["@/components/ShopingCart"],resolve)),
            },
            {
                path: 'InAppPurchase',
                name: 'InAppPurchase',
                component: resolve=>(require(["@/components/InAppPurchase"],resolve)),
            },
              {
                  path: '',
                  name: 'dashboard',
                  component: resolve=>(require(["@/components/Dashboard"],resolve)),
              },
              {
                  path: '/base',
                  name: 'base',
                  component: resolve=>(require(["@/components/BaseData"],resolve)),
              },
              {
                path: '/addorder',
                name: 'addorder',
                component: resolve=>(require(["@/components/AddOrder"],resolve))
            },
            {
                path: '/AddProductToOrder',
                name: 'AddProductToOrder',
                component: resolve=>(require(["@/components/AddProductToOrder"],resolve)),
            },
              {
                  path: '/oa',
                  name: 'oa',
                  component: resolve=>(require(["@/components/OA"],resolve)),
              },{
                  path: '/filetype',
                  name: 'filetype',
                  component: resolve=>(require(["@/components/FileType"],resolve)),
              },{
                  path: '/filelist',
                  name: 'filelist',
                  component: resolve=>(require(["@/components/FileLists"],resolve)),
              },{
                  path: '/setting',
                  name: 'setting',
                  component: resolve=>(require(["@/components/Setting"],resolve)),
              },

              {
                  path: '/help',
                  name: 'help',
                  component: resolve=>(require(["@/components/Help"],resolve)),
              },
              {
                  path: '/purchase',
                  name: 'purchase',
                  //component:Purchase,
                  component: resolve=>(require(["@/components/Purchase"],resolve)),
              },
              {
                  path: '/purchasereturn',
                  name: 'purchasereturn',
                  component: resolve=>(require(["@/components/Purchase"],resolve)),
              },
              {
                  path: '/sell',
                  name: 'sell',
                  component: resolve=>(require(["@/components/Purchase"],resolve)),
              },
              {
                  path: '/sellreturn',
                  name: 'sellreturn',
                  component: resolve=>(require(["@/components/Purchase"],resolve)),
              },
              {
                  path: '/purchaseorder',
                  name: 'purchaseorder',
                  component: resolve=>(require(["@/components/Order"],resolve)),
              },
              {
                path: '/liuyan',
                name: 'liuyan',
                component: resolve=>(require(["@/components/Liuyan"],resolve)),
            },
              {
                  path: '/purchasereturnorder',
                  name: 'purchasereturnorder',
                  component: resolve=>(require(["@/components/Order"],resolve)),
              },
              {
                  path: '/sellorder',
                  name: 'sellorder',
                  component: resolve=>(require(["@/components/Order"],resolve)),
              },
              {
                  path: '/sellreturnorder',
                  name: 'sellreturnorder',
                  component: resolve=>(require(["@/components/Order"],resolve)),
              },

              {
                  path: '/addpurchase',
                  name: 'addpurchase',
                  component: resolve=>(require(["@/components/AddPurchase"],resolve)),
              },
              {
                  path: '/product',
                  name: 'product',
                  component: resolve=>(require(["@/components/Product"],resolve)),
              },
              {
                path: '/uploadexcel',
                name: 'uploadexcel',
                component: resolve=>(require(["@/components/UploadExcel"],resolve)),
            },{
                path: '/uploadexcelorder',
                name: 'uploadexcelorder',
                component: resolve=>(require(["@/components/UploadExcelOrder"],resolve)),
            },
            {
                path: '/shipping',
                name: 'shipping',
                component: resolve=>(require(["@/components/Shipping"],resolve)),
            },
            {
              path: '/backup',
              name: 'backup',
              component: resolve=>(require(["@/components/Backup"],resolve)),
          },{
            path: '/logout',
            name: 'logout',
            component: resolve=>(require(["@/components/logout"],resolve)),
        },
              {
                  path: '/user',
                  name: 'user',
                  component: resolve=>(require(["@/components/User"],resolve)),
              },{
                path: '/userinfo',
                name: 'userinfo',
                component: resolve=>(require(["@/components/UserInfo"],resolve)),
            },{
                path: '/userbuy',
                name: 'userbuy',
                component: resolve=>(require(["@/components/UserBuy"],resolve)),
            },
              {
                  path: '/warehouse',
                  name: 'warehouse',
                  component: resolve=>(require(["@/components/Warehouse"],resolve)),
              },
              {
                  path: '/supplier',
                  name: 'supplier',
                  component: resolve=>(require(["@/components/Supplier"],resolve)),
              },
              {
                path: '/customer',
                name: 'customer',
                component: resolve=>(require(["@/components/Supplier"],resolve)),
            },
            {
                path: '/trendhome',
                name: 'trendhome',
                component: resolve=>(require(["@/components/TrendHome"],resolve)),
            },
              {
                  path: '/trend',
                  name: 'trend',
                  component: resolve=>(require(["@/components/Trend"],resolve)),
              },
              {
                path: '/shouldpay',
                name: 'shouldpay',
                component: resolve=>(require(["@/components/ShouldPay"],resolve)),
            },
            {
                path: '/topsell',
                name: 'topsell',
                component: resolve=>(require(["@/components/TopSell"],resolve)),
            },
            {
                path: '/TrendCharts',
                name: 'TrendCharts',
                component: resolve=>(require(["@/components/TrendCharts"],resolve)),
            },

              {
                path: '/trenddate',
                name: 'trenddate',
                component: resolve=>(require(["@/components/TrendDate"],resolve)),
            },
            {
              path: '/chosedata',
              name: 'chosedata',
              component: resolve=>(require(["@/components/ChoseData"],resolve)),
          },
              {
                  path: '/addtype',
                  name: 'addtype',
                  component: resolve=>(require(["@/components/AddType"],resolve)),
              },{
                  path: '/type',
                  name: 'type',
                  component: resolve=>(require(["@/components/ProductType"],resolve)),
              },{
                  path: '/typetwo',
                  name: 'typetwo',
                  component: resolve=>(require(["@/components/TypeTwo"],resolve)),
              },{
                  path: '/inventory',
                  name: 'inventory',
                  component: resolve=>(require(["@/components/Inventory"],resolve)),
              },
              {
                  path: '/WorkReport',
                  name: 'WorkReport',
                  component: resolve=>(require(["@/components/OAWorkReport"],resolve)),
              },
              {
                  path: '/CheckIn',
                  name: 'CheckIn',
                  component: resolve=>(require(["@/components/OACheckIn"],resolve)),
              },
              {
                  path: '/Announcement',
                  name: 'Announcement',
                  component: resolve=>(require(["@/components/OAAnnouncement"],resolve)),
              },
              {
                  path: '/Approval',
                  name: 'Approval',
                  component: resolve=>(require(["@/components/OAApproval"],resolve)),
              },
              {
                  path: '/Tracking',
                  name: 'Tracking',
                  component: resolve=>(require(["@/components/OATracking"],resolve)),
              },
              {
                  path: '/Leave',
                  name: 'Leave',
                  component: resolve=>(require(["@/components/OALeave"],resolve)),
              },
              {
                  path: '/Bill',
                  name: 'Bill',
                  component: resolve=>(require(["@/components/Account"],resolve)),
              },
              {
                path: '/TrendCost',
                name: 'TrendCost',
                component: resolve=>(require(["@/components/TrendCost"],resolve)),
            },
              {
                  path: '/picture',
                  name: 'picture',
                  component: resolve=>(require(["@/components/ShowPicture"],resolve)),
              },
              {
                  path: '/bigpicture',
                  name: 'bigpicture',
                  component: resolve=>(require(["@/components/BigPicture"],resolve)),
              },
              {
                  path: '/print',
                  name: 'print',
                  component: resolve=>(require(["@/components/Printer"],resolve)),
              },
              {
                path: '/printsimple',
                name: 'printsimple',
                component: resolve=>(require(["@/components/PrinterSimple"],resolve)),
            },
              {
                  path: '/power',
                  name: 'power',
                  component: resolve=>(require(["@/components/UserPower"],resolve)),
              },
              {
                path: '/password',
                name: 'password',
                component: resolve=>(require(["@/components/UserPassword"],resolve)),
            },
              {
                  path: '/hotel',
                  name: 'hotel',
                  component: resolve=>(require(["@/components/Hotel"],resolve)),
              },
              {
                  path: '/building',
                  name: 'building',
                  component: resolve=>(require(["@/components/Hotel_Building"],resolve)),
              },
              {
                  path: '/room',
                  name: 'room',
                  component: resolve=>(require(["@/components/Hotel_Room"],resolve)),
              },
              {
                  path: '/hoteluser',
                  name: 'hoteluser',
                  component: resolve=>(require(["@/components/Hotel_User"],resolve)),
              },
              {
                path: '/sendemail',
                name: 'sendemail',
                component: resolve=>(require(["@/components/SendEmail"],resolve)),
            },
              {
                  path: '/hoteluserrent',
                  name: 'hoteluserrent',
                  component: resolve=>(require(["@/components/Hotel_UserRent"],resolve)),
              },
              {
                  path: '/hotelcheckin',
                  name: 'hotelcheckin',
                  component: resolve=>(require(["@/components/Hotel_CheckInOut"],resolve)),
              },
              {
                  path: '/my',
                  name: 'my',
                  component: resolve=>(require(["@/components/My"],resolve)),
              },
              {
                  path: '/iprecord',
                  name: 'iprecord',
                  component: resolve=>(require(["@/components/IpRecord"],resolve)),
              },
              {
                  path: '/historyprice',
                  name: 'historyprice',
                  component: resolve=>(require(["@/components/HistoryPrice"],resolve)),
              },
              {
                  path: '/stocktransfer',
                  name: 'stocktransfer',
                  component: resolve=>(require(["@/components/StockTransfer"],resolve)),
              },{
                path: '/AddPayment',
                name: 'AddPayment',
                component: resolve=>(require(["@/components/payment/AddPayment"],resolve)),
            },{
                path: '/AddShipping',
                name: 'AddShipping',
                component: resolve=>(require(["@/components/payment/AddShipping"],resolve)),
            },{
                path: '/AddMoneyType',
                name: 'AddMoneyType',
                component: resolve=>(require(["@/components/payment/AddMoneyType"],resolve)),
            },{
                path: '/Payment',
                name: 'Payment',
                component: resolve=>(require(["@/components/payment/Payment"],resolve)),
            },{
                path: '/Shipping',
                name: 'Shipping',
                component: resolve=>(require(["@/components/payment/Shipping"],resolve)),
            },{
                path: '/MoneyType',
                name: 'MoneyType',
                component: resolve=>(require(["@/components/payment/MoneyType"],resolve)),
            },{
                path: '/TypeManage',
                name: 'TypeManage',
                component: resolve=>(require(["@/components/TypeManage"],resolve)),
            },{
                path: '/FactoryHome',
                name: 'FactoryHome',
                component: resolve=>(require(["@/components/Factory/FactoryHome"],resolve)),
            },
            {
                path: '/bom',
                name: 'bom',
                component: resolve=>(require(["@/components/Factory/BOM"],resolve)),
            },
            {
                path: '/bomproce',
                name: 'bomproce',
                component: resolve=>(require(["@/components/Factory/BomProce"],resolve)),
            },
            {
                path: '/addbom',
                name: 'addbom',
                component: resolve=>(require(["@/components/Factory/AddBOM"],resolve)),
            },
            {
                path: '/AddBomProce',
                name: 'AddBomProce',
                component: resolve=>(require(["@/components/Factory/AddBomProce"],resolve)),
            },

            {
                path: '/materials',
                name: 'materials',
                component: resolve=>(require(["@/components/Factory/materials"],resolve)),
            },
            {
                path: '/task',
                name: 'task',
                component: resolve=>(require(["@/components/Factory/task"],resolve)),
            },

            {
                path: '/processes',
                name: 'processes',
                component: resolve=>(require(["@/components/Factory/processes"],resolve)),
            },{
                path: '/temp',
                name: 'temp',
                component: resolve=>(require(["@/components/Factory/temp"],resolve)),
            },
          ]
      }
  ]
})
/*
import Home from '@/components/home'

import Index from '@/components/index'
import BaseData from '@/components/BaseData'
import Trend from '@/components/Trend'
import TrendDate from '@/components/TrendDate'
import ProductType from '@/components/ProductType'
import AddType from '@/components/AddType'
import Login from '@/components/login'

//import Product from '@/components/Product'
import User from '@/components/User'
import Warehouse from '@/components/Warehouse'
import Supplier from '@/components/Supplier'
import TypeTwo from '@/components/TypeTwo'
import Purchase from '@/components/Purchase'
import Inventory from '@/components/Inventory'
import Order from '@/components/Order'
import AddPurchase from '@/components/AddPurchase'
import WorkReport  from '@/components/OAWorkReport'
import CheckIn from '@/components/OACheckIn'
import Announcement from '@/components/OAAnnouncement'
import Approval from '@/components/OAApproval'
import Tracking from '@/components/OATracking'
import OA from '@/components/OA'
import Leave from '@/components/OALeave'
import Bill from '@/components/Account'
import ShowPicture from '@/components/ShowPicture'
import BigPicture from '@/components/BigPicture'
import Print from '@/components/Printer'
import UserPower from '@/components/UserPower'
import help from '@/components/Help'
import Setting from '@/components/Setting'
import Invoice from '@/components/Invoice'
import Hotel from '@/components/Hotel'
import Hotel_Building from '@/components/Hotel_Building'
import Hotel_CheckInOut from '@/components/Hotel_CheckInOut'
import Hotel_User from '@/components/Hotel_User'
import Hotel_UserRent from '@/components/Hotel_UserRent'
import Hotel_Room from '@/components/Hotel_Room'
import UploadExcel from '@/components/UploadExcel'
import AddOrder from '@/components/AddOrder'
import ShopingCart from '@/components/ShopingCart'
import InAppPurchase from '@/components/InAppPurchase'
import AddProductToOrder from '@/components/AddProductToOrder'
import Liuyan from '@/components/Liuyan'
import homeApp from '@/components/homeApp'
import appbase from '@/components/appBaseData'
import appinvoice from '@/components/appInvoice'
import Shop from '@/components/Shop'
*/


/*
import Home from '@/components/home'
import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
//const Vue = ()=>import('vue')
//const Router = ()=>import('vue-router')



import Login from '@/components/login'


const Index = ()=>import('@/components/index')
const BaseData = ()=>import('@/components/BaseData')
const Trend = ()=>import('@/components/Trend')
const TrendDate = ()=>import('@/components/TrendDate')
const ProductType = ()=>import('@/components/ProductType')
const AddType = ()=>import('@/components/AddType')


const Product = ()=>import('@/components/Product')
const User = ()=>import('@/components/User')
const Warehouse = ()=>import('@/components/Warehouse')
const Supplier = ()=>import('@/components/Supplier')
const TypeTwo = ()=>import('@/components/TypeTwo')
const Purchase = ()=>import('@/components/Purchase')




const Inventory = ()=>import('@/components/Inventory')
const Order = ()=>import('@/components/Order')
const AddPurchase = ()=>import('@/components/AddPurchase')


const WorkReport  = ()=>import('@/components/OAWorkReport')
const CheckIn = ()=>import('@/components/OACheckIn')
const Announcement = ()=>import('@/components/OAAnnouncement')
const Approval = ()=>import('@/components/OAApproval')
const Tracking = ()=>import('@/components/OATracking')
const OA = ()=>import('@/components/OA')
const Leave = ()=>import('@/components/OALeave')
const Bill = ()=>import('@/components/Account')
const ShowPicture = ()=>import('@/components/ShowPicture')
const BigPicture = ()=>import('@/components/BigPicture')
const Print = ()=>import('@/components/Printer')
const UserPower = ()=>import('@/components/UserPower')
const help = ()=>import('@/components/Help')
const Setting = ()=>import('@/components/Setting')
const Invoice = ()=>import('@/components/Invoice')
const Hotel = ()=>import('@/components/Hotel')
const Hotel_Building = ()=>import('@/components/Hotel_Building')
const Hotel_CheckInOut = ()=>import('@/components/Hotel_CheckInOut')
const Hotel_User = ()=>import('@/components/Hotel_User')
const Hotel_UserRent = ()=>import('@/components/Hotel_UserRent')
const Hotel_Room = ()=>import('@/components/Hotel_Room')
const UploadExcel = ()=>import('@/components/UploadExcel')
const AddOrder = ()=>import('@/components/AddOrder')
const ShopingCart = ()=>import('@/components/ShopingCart')
const InAppPurchase = ()=>import('@/components/InAppPurchase')
const AddProductToOrder = ()=>import('@/components/AddProductToOrder')
const Liuyan = ()=>import('@/components/Liuyan')
const homeApp = ()=>import('@/components/homeApp')
const appbase = ()=>import('@/components/appBaseData')
const appinvoice = ()=>import('@/components/appInvoice')
const Shop = ()=>import('@/components/Shop')
*/
/*

export default new Router({
    // mode: 'history',
   routes: [
     {
         path: '/invoicee',
         name: 'invoice',
         component: Invoice,
     },
     {
         path: '/shop',
         name: 'shop',
         component: Shop,
     }
     ,{
         path: '/login',
         name: 'login',
         component: Login
     },
     {
         path: '/app',
         name: 'app',
         component: homeApp,
         children: [
           {name: 'app_invoice', path: '/app_invoice', component: appinvoice},
           {name: 'app_base', path: '/app_base', component: appbase},
           {name: 'app_user', path: '/app_user', component: Setting}
         ]
       },
     {
         path: '/',
         component: Home,
           children: [
             {
                 path: '/invoice',
                 name: 'invoice',
                 component: Invoice,
             },
             {
                 path: 'ShopingCart',
                 name: 'ShopingCart',
                 component:ShopingCart
             },
             {
                 path: 'InAppPurchase',
                 name: 'InAppPurchase',
                 component:InAppPurchase
             },
               {
                   path: '',
                   name: 'setting',
                   component:Setting
               },
               {
                   path: '/base',
                   name: 'base',
                   component:BaseData,
               },
               {
                 path: '/addorder',
                 name: 'addorder',
                 component:AddOrder,
             },
             {
                 path: '/AddProductToOrder',
                 name: 'AddProductToOrder',
                 component:AddProductToOrder,
             },
               {
                   path: '/oa',
                   name: 'oa',
                   component:OA,
               },{
                   path: '/setting',
                   name: 'setting',
                   component:Setting,
               },
               {
                   path: '/help',
                   name: 'help',
                   component:help,
               },
               {
                   path: '/purchase',
                   name: 'purchase',
                   component:Purchase,
               },
               {
                   path: '/purchasereturn',
                   name: 'purchasereturn',
                   component:Purchase,
               },
               {
                   path: '/sell',
                   name: 'sell',
                   component:Purchase,
               },
               {
                   path: '/sellreturn',
                   name: 'sellreturn',
                   component:Purchase,
               },
               {
                   path: '/purchaseorder',
                   name: 'purchaseorder',
                   component:Order,
               },
               {
                 path: '/liuyan',
                 name: 'liuyan',
                 component:Liuyan,
             },
               {
                   path: '/purchasereturnorder',
                   name: 'purchasereturnorder',
                   component:Order,
               },
               {
                   path: '/sellorder',
                   name: 'sellorder',
                   component:Order,
               },
               {
                   path: '/sellreturnorder',
                   name: 'sellreturnorder',
                   component:Order,
               },

               {
                   path: '/addpurchase',
                   name: 'addpurchase',
                   component:AddPurchase,
               },
               {
                   path: '/product',
                   name: 'product',
                   component: resolve=>(require(["@/components/Product"],resolve)),
               },
               {
                 path: '/uploadexcel',
                 name: 'uploadexcel',
                 component:UploadExcel,
             },
               {
                   path: '/user',
                   name: 'user',
                   component:User,
               },
               {
                   path: '/warehouse',
                   name: 'warehouse',
                   component:Warehouse,
               },
               {
                   path: '/supplier',
                   name: 'supplier',
                   component:Supplier,
               },
               {
                 path: '/customer',
                 name: 'customer',
                 component:Supplier,
             },
               {
                   path: '/trend',
                   name: 'trend',
                   component: Trend
               },
               {
                 path: '/trenddate',
                 name: 'trenddate',
                 component: TrendDate
             },
               {
                   path: '/addtype',
                   name: 'addtype',
                   component: AddType
               },{
                   path: '/type',
                   name: 'type',
                   component: ProductType
               },{
                   path: '/typetwo',
                   name: 'typetwo',
                   component: TypeTwo
               },{
                   path: '/inventory',
                   name: 'inventory',
                   component: Inventory
               },
               {
                   path: '/WorkReport',
                   name: 'WorkReport',
                   component:WorkReport,
               },
               {
                   path: '/CheckIn',
                   name: 'CheckIn',
                   component:CheckIn,
               },
               {
                   path: '/Announcement',
                   name: 'Announcement',
                   component:Announcement,
               },
               {
                   path: '/Approval',
                   name: 'Approval',
                   component:Approval,
               },
               {
                   path: '/Tracking',
                   name: 'Tracking',
                   component:Tracking,
               },
               {
                   path: '/Leave',
                   name: 'Leave',
                   component:Leave,
               },
               {
                   path: '/Bill',
                   name: 'Bill',
                   component:Bill,
               },
               {
                   path: '/picture',
                   name: 'picture',
                   component: ShowPicture,
               },
               {
                   path: '/bigpicture',
                   name: 'bigpicture',
                   component: BigPicture,
               },
               {
                   path: '/print',
                   name: 'print',
                   component: Print,
               },
               {
                   path: '/power',
                   name: 'power',
                   component: UserPower,
               },
               {
                   path: '/invoice',
                   name: 'invoice',
                   component: Invoice,
               },
               {
                   path: '/hotel',
                   name: 'hotel',
                   component: Hotel,
               },
               {
                   path: '/building',
                   name: 'building',
                   component: Hotel_Building,
               },
               {
                   path: '/room',
                   name: 'room',
                   component: Hotel_Room,
               },
               {
                   path: '/hoteluser',
                   name: 'hoteluser',
                   component:Hotel_User,
               },
               {
                   path: '/hoteluserrent',
                   name: 'hoteluserrent',
                   component: Hotel_UserRent,
               },
               {
                   path: '/hotelcheckin',
                   name: 'hotelcheckin',
                   component: Hotel_CheckInOut,
               }
           ]
       }

   ]
 })

*/




// WEBPACK FOOTER //
// ./src/router/index.js